<script>
import useVuelidate from '@vuelidate/core';
import { required, minLength, sameAs } from '@vuelidate/validators';

import appConfig from "@/app.config";
import AuthLayer from "@/router/views/account/AuthLayer";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {AuthLayer},
  page: {
    title: "Password Change",
    meta: [{ name: "description", content: appConfig.description }],
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
    };
  },
  computed: {
    ... mapGetters({
      authLoading: 'authentication/authLoading',
      authErrors: 'authentication/authErrors'
    })
  },
   methods: {
     ... mapActions({
       forgotPassword: 'authentication/forgotPassword'
     }),
    async changePasswordFn() {
      this.submitted = true;

      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }
      await this.forgotPassword({newPassword:this.password, confirmPassword: this.confirmPassword, resetToken: this.$route.params.token})

      this.v$.$touch();
    },
  },
  validations () {
    return {
      password: {
        required, minLength: minLength(8)
      },
      confirmPassword: {
        required, sameAs: sameAs(this.password)
      }
    }
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
  },
};
</script>

<template>
  <AuthLayer>
    <div>
      <div>
        <h1 class="text-primary">Change Password</h1>
      </div>
      <div class="mt-4">
        <form @submit.prevent="changePasswordFn">
          <b-alert
              v-model="isResetError"
              class="mb-4"
              variant="danger"
              dismissible
          >{{ error }}</b-alert
          >

          <div class="my-4">
            <label for="password" class="h5">Password</label>
            <input
                type="password"
                v-model="password"
                class="form-control py-3"
                id="password"
                placeholder="Enter password"
                :class="{ 'is-invalid': submitted && v$.password.$error }"
            />
            <p
                v-for="error of v$.password.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>

          <div class="my-4">
            <label for="confirm-password" class="h5">Confirm Password</label>
            <input
                type="password"
                v-model="confirmPassword"
                class="form-control py-3"
                id="confirm-password"
                placeholder="Enter password"
                :class="{ 'is-invalid': submitted && v$.confirmPassword.$error }"
            />
            <div v-if="v$.confirmPassword.$error" class="invalid-feedback">
              <span v-if="v$.confirmPassword.required.$invalid">Confirm Password is required</span>
              <span v-else-if="v$.confirmPassword.sameAs.$invalid">Passwords must match</span>
            </div>
          </div>

          <div v-for="(error, index) in authErrors" :key="index" style="color: #D13704;">
            {{error.message}}
          </div>

          <div class="mt-3 d-grid">
            <b-button variant="primary" size="lg" v-if="authLoading" disabled>
              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              Loading
            </b-button>
            <b-button v-else variant="primary" size="lg" class="py-3 h3 text-white" type="submit">Reset</b-button>
          </div>
        </form>
        <div class="mt-5 text-center h5">
          <p>
            Remember It ?
            <router-link
                to="/"
                class="fw-medium text-primary">
              Log In</router-link>
          </p>
        </div>
      </div>
    </div>
  </AuthLayer>
</template>

<style lang="scss" scoped>
::v-deep .carousel-caption {
  position: relative !important;
  right: 0;
  left: 0;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #495057;
}

::v-deep .carousel-indicators li {
  background-color: rgba(85, 110, 230, 0.25);
}
</style>
